import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';
import { differenceInCalendarMonths } from 'date-fns';
import debounce from '../../utils/debounce.js';

var useNrOfMonthsDisplayedDesktop = function useNrOfMonthsDisplayedDesktop(datePickerWrapperRef) {
  var _useState = useState(3),
    _useState2 = _slicedToArray(_useState, 2),
    nrOfMonthsDisplayedDesktop = _useState2[0],
    setNrOfMonthsDisplayedDesktop = _useState2[1];
  useEffect(function () {
    var getNrOfMonths = function getNrOfMonths() {
      return datePickerWrapperRef.current.offsetWidth > 1100 ? 3 : 2;
    };
    var handleResize = function handleResize() {
      if (datePickerWrapperRef.current) {
        setNrOfMonthsDisplayedDesktop(getNrOfMonths());
      }
    };
    if (datePickerWrapperRef.current) {
      setNrOfMonthsDisplayedDesktop(getNrOfMonths());
    }
    window.addEventListener('resize', debounce(handleResize, 100));
    return function () {
      window.removeEventListener('resize', debounce(handleResize, 100));
    };
  }, [datePickerWrapperRef]);
  return nrOfMonthsDisplayedDesktop;
};

// export const useWindowResize = (onResize) => {
//   useEffect(() => {
//     onResize();
//     window.addEventListener('resize', debounce(onResize, 100));
//     return () => window.removeEventListener('resize', debounce(onResize, 100));
//   }, [onResize]);
// };

// Uses selected* props to figure out which month display first in the popup.
// returns index of month
function getFirstSelectedMonthIndex(selectedMonths, selectedDate, selectedInterval, startDate) {
  // selectedMonths overrides the other two arguments so check it first.
  if (Array.isArray(selectedMonths) && selectedMonths.length) {
    var months = selectedMonths.slice();
    months.sort();
    try {
      return differenceInCalendarMonths(new Date(months[0]), new Date(startDate));
    } catch (e) {
      return 0;
    }
  }
  if (selectedInterval !== null && selectedInterval !== void 0 && selectedInterval.from && selectedInterval !== null && selectedInterval !== void 0 && selectedInterval.to) {
    try {
      return differenceInCalendarMonths(new Date(selectedInterval.from), new Date(startDate));
    } catch (e) {
      return 0;
    }
  }
  if (selectedDate) {
    try {
      return differenceInCalendarMonths(new Date(selectedDate), new Date(startDate));
    } catch (e) {
      return 0;
    }
  }
  return 0;
}
var isMonthSelected = function isMonthSelected(date, selectedMonths) {
  var y = date.getUTCFullYear();
  var m = date.getMonth();
  return !!(selectedMonths !== null && selectedMonths !== void 0 && selectedMonths.find(function (month) {
    var d = new Date(month);
    return d.getUTCFullYear() === y && d.getMonth() === m;
  })); // YYYY-MM
};
var isSmallScreen = function isSmallScreen() {
  return typeof window !== 'undefined' && window && window.innerWidth < 768;
};

// export const isWideTemplate = () =>
//   typeof window !== 'undefined' &&
//   window &&
//   window.innerWidth >= 1280 &&
//   document.getElementsByClassName("idun-wide-body").length > 0;

export { getFirstSelectedMonthIndex, isMonthSelected, isSmallScreen, useNrOfMonthsDisplayedDesktop };
//# sourceMappingURL=utils.js.map
